import React from 'react';

export default function LiveJobStatus({ status }) {
  if (status === 'live') return <span className="text-muted small" role="status">Live updates connected</span>;
  return <div className="text-muted small mb-2" role="status">
    {status === 'unavailable' ? 'Live updates unavailable. Refresh to see the latest status.' :
      status === 'connecting' ? 'Connecting live updates…' : 'Connection interrupted. Reconnecting…'}
  </div>;
}
